import i18n from '../i18n'
import { LEVEL_LABELS } from './home'
import { normalizeWeek } from './progress'

/**
 * The profile tab's rules (design page 13, `profile`; P-profile of the
 * go-live plan), mirrored from the Android app's `ProfileScreen.kt` and
 * `docs/screens.md` §6.
 */

const t = (key, options) => i18n.t(key, { ns: 'profile', ...options })

/** The name on the header: the server's display name, else the phone, else «کاربر طوطی». */
export function profileName(user) {
  const display = String(user?.displayName ?? '').trim()
  if (display) return display
  const phone = String(user?.phone ?? '').trim()
  return phone || t('anonymousName')
}

/** «سطح متوسط», or nothing for a level this build does not know. */
export function levelLine(level) {
  const label = LEVEL_LABELS[level]
  return label ? t('levelLine', { level: label }) : ''
}

/** Which of the seven days (Saturday first) got a gold tick: any minute practised. */
export function practisedDays(weekMinutes) {
  return normalizeWeek(weekMinutes).map((minutes) => minutes > 0)
}
